const getEyeSide = (typeDetails)=>{
    if (typeDetails && 'eyeSide' in typeDetails && typeDetails.eyeSide) {
        return typeDetails.eyeSide.toLowerCase();
    }
    return;
};

export { getEyeSide };
//# sourceMappingURL=get-eye-side.js.map
